// import React, { useEffect, useState } from 'react'
// import CustomTable from '../../../components/customTable/customTable';
// import Accordian from '../../../components/Accordian';
// import { useDispatch, useSelector } from 'react-redux';
// import IpoAccordian from '../../../components/IpoAccordian';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { getIpoDetail } from '../../../api/IposApi';
// import { startMasterLoding, stopMasterLoding } from '../../../store/slice/masterSlice';
// import { setIpoDetail } from '../../../utils/npm';
// import { formatCurrency, formatDate, formatIndianPrice, formatIPOValue, TABKEY } from '../../../components/CommonFunction';

// export const IpoDetails = ({ location }) => {

//     const navigate = useNavigate();
//     const { faqData, error, loading } = useSelector(state => state.fagListData)
//     const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail)
//     const isloading = useSelector((state) => state.masterSlice.isloading);
//     const [total, setTotal] = useState([])
//     const { id } = useParams();

//     useEffect(() => {

//         const totals = ipoDetailData?.ipo_subscription_detail?.length > 0 && ipoDetailData?.ipo_subscription_detail?.reduce(
//             (acc, item) => {
//                 if (
//                     item.category !== 'Total' &&
//                     item.category.trim().toLowerCase() !== 'hnis(10l +)' &&
//                     // item.category !== 'hnis(10l+)' &&
//                     item.category.trim().toLowerCase() !== 'hnis (2-10l)'
//                 ) {
//                     acc.times += item.times ?? 0
//                     acc.offered += item.offered ?? 0
//                     acc.applied += item.applied ?? 0
//                 }
//                 return acc
//             },
//             { times: 0, offered: 0, applied: 0 }
//         )

//         const investorCategoryTotal = ipoDetailData?.ipo_reservation?.reduce(
//             (acc, item) => {
//                 if (item.investor_category !== 'Total') {
//                     acc.no_of_shares += item.no_of_shares ?? 0
//                     acc.shares_offered += item.shares_offered ?? 0
//                 }
//                 return acc
//             },
//             {
//                 no_of_shares: 0,
//                 shares_offered: 0
//             }
//         )

//         const totalApplied = ipoDetailData?.appplication_wise_breakup?.data?.reduce(
//             (accumulator, currentItem) => {
//                 const appliedValue = Number(currentItem.applied) || 0 // Ensure applied is numeric
//                 return accumulator + appliedValue
//             },
//             0
//         )

//         setTotal(prevState => ({
//             ...prevState,
//             ipo_subscription_detail: {
//                 ...prevState.ipo_subscription_detail,
//                 times: totals?.times,
//                 offered: totals?.offered,
//                 applied: totals?.applied
//             },
//             investorCategoryTotal: {
//                 ...prevState?.investorCategoryTotal,
//                 no_of_shares: investorCategoryTotal?.no_of_shares,
//                 shares_offered: investorCategoryTotal?.shares_offered
//             },
//             application_wise_breakup: {
//                 ...prevState?.application_wise_breakup,
//                 totalApplied: totalApplied
//             },
//             ipoDetails: {
//                 ipo_start_date: ipoDetailData?.start_date,
//                 ipo_end_date: ipoDetailData?.end_date,
//                 listing_date: ipoDetailData?.listing_date,
//                 allotment_date: ipoDetailData?.allotment_date,
//                 issue_size: ipoDetailData?.issue_size,
//                 issue_type: ipoDetailData?.issue_type?.issue_type,
//                 issue_price: ipoDetailData?.issue_price?.issue_price,
//                 issue_amount: ipoDetailData?.issue_amount,
//                 fresh_issue_size: ipoDetailData?.fresh_issue_size,
//                 fresh_issue_value: ipoDetailData?.fresh_issue_value,
//                 face_value: ipoDetailData?.face_value,
//                 // s_hni_lot_size : ipoDetailData?.s_hni_lot_size,
//                 bid_lot: formatIndianPrice(ipoDetailData?.bid_lot),
//                 listing_at_group: ipoDetailData?.listing_at_group,
//                 symbol: ipoDetailData?.symbol,
//                 post_issue_share_holding: ipoDetailData?.post_issue_share_holding,
//                 pre_issue_share_holding: ipoDetailData?.pre_issue_share_holding,
//                 price_range: ipoDetailData?.price_range,
//                 market_maker_offered: ipoDetailData?.market_maker_offered,
//                 offer_of_sale_value: ipoDetailData?.offer_of_sale_value,
//                 offer_of_sale: ipoDetailData?.offer_of_sale
//             },
//             ipo_lot_description: ipoDetailData?.ipo_lot_description,
//             key_performance_indicator: ipoDetailData?.key_performance_indicator,
//             company_financial_data: ipoDetailData?.company_financial_data,
//             interest_cost_per_share: ipoDetailData?.interest_cost_per_share,
//             ipo_reservation: ipoDetailData?.ipo_reservation
//         }))

//     }, [id, ipoDetailData])

//     // ---------------------------- Details Data --------------------------------------

//     const [ipoDetailsCol, setIpoDetailsCol] = useState([])
//     const [ipoReservationCol, setIpoReservationCol] = useState([])
//     const [lotSizeCol, setLotSizeCol] = useState([])
//     const [financialCol, setFinancialCol] = useState([])
//     const [performenceCal, setPerformenceCal] = useState([])

//     const registrarDetails = ipoDetailData?.registrar_detail ? ipoDetailData.registrar_detail?.split(', ') : [];
//     const [registrar_name, registrar_phone, registrar_email, registrar_website] = registrarDetails;

//     useEffect(() => {

//         if (total?.ipoDetails) {
//             const ipoDetailArray = [
//                 { label: 'IPO Date', value: `${formatDate(total?.ipoDetails?.ipo_start_date)} to ${formatDate(total?.ipoDetails?.ipo_end_date)}` },
//                 { label: 'Allotment Date', value: `${total?.ipoDetails?.allotment_date != null ? formatDate(total?.ipoDetails?.allotment_date) : '-'}` },
//                 { label: 'List Date', value: `${total?.ipoDetails?.listing_date != null ? formatDate(total?.ipoDetails?.listing_date) : '' || '-'}` },
//                 { label: 'Lot Size', value: formatIndianPrice(total?.ipoDetails.bid_lot) + ' share' },
//                 { label: 'Issue Price', value: total?.ipoDetails?.price_range },
//                 { label: 'Issue Size', value: formatIndianPrice(total?.ipoDetails?.issue_size) + ` ( aggregating up to ${total?.ipoDetails.issue_amount || 0.00} Cr )` },
//                 { label: 'Fresh Issue', value: `${formatIndianPrice(total?.ipoDetails?.fresh_issue_value)} ( aggregating up to ${total?.ipoDetails?.fresh_issue_size || 0.00} Cr )` },
//                 { label: 'Offer For Sale', value: `${formatIndianPrice(total?.ipoDetails?.offer_of_sale)} ( aggregating up to ${total?.ipoDetails?.offer_of_sale_value || 0.00} Cr )` },

//                 // { label: 'Face Value', value: total?.ipoDetails?.face_value },
//                 { label: 'Listing At', value: total?.ipoDetails?.listing_at_group || '-' },
//                 { label: 'Share Holding Pre-Issue', value: formatIndianPrice(total?.ipoDetails?.pre_issue_share_holding) },
//                 { label: 'Share Holding Post-Issue', value: formatIndianPrice(total?.ipoDetails?.post_issue_share_holding) },
//                 { label: 'Market Marker Portion', value: formatIndianPrice(total?.ipoDetails?.market_maker_offered) },
//             ];
//             setIpoDetailsCol(ipoDetailArray);
//         }

//         if (total?.sharesData) {

//             const ReservationArray = [
//                 { label: 'QIB Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 75% of the Offer' },
//                 { label: 'NII (HNI) Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 15% of the Offer' },
//                 { label: 'Retail Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 10% of the Offer' }
//             ];
//             setIpoReservationCol(ReservationArray);

//         }

//         if (total?.ipo_lot_description) {

//             const LotSizeArray = total?.ipo_lot_description?.length > 0 && total?.ipo_lot_description?.map(item => ({
//                 label: 'IPO Date',
//                 application: item?.category === "RETAIL" ? "Retail (Min)" : item?.category,
//                 lot: item["lot(s)"].toString(),
//                 share: item?.qty?.toString(),
//                 ammount: formatIndianPrice(item?.amount),//formatIndianPrice(`₹${item?.amount?.toLocaleString()}`),
//                 reserved: item?.reserved
//             }));

//             setLotSizeCol(LotSizeArray);
//         }

//         if (total?.company_financial_data?.financial_data) {
//             const financialArray = total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data?.slice(1).map((row) => ({
//                 period: row.period_ended,
//                 assets: `${row.assets}`,
//                 revenue: `${row.revenue}`,
//                 netWorth: `${row.net_worth}`,
//                 totalBorrowing: `${row.total_borrowing}`,
//                 profitAfterTax: `${row.profit_after_tax}`,
//                 reservesAndSurplus: `${row.reserves_and_surpluse}`,
//             }));
//             setFinancialCol(financialArray);
//         }

//         if (total?.key_performance_indicator?.length > 0) {
//             const formattedKpiData = [
//                 // { label: "Kpi", value: kpi },
//                 { label: total?.key_performance_indicator[0]?.ronw, value: `${total?.key_performance_indicator[0]?.ronw}%` }, // RoNW
//                 { label: "Debt/Equity", value: "1.45" }, // Manually added (if available in the full dataset)
//             ];

//             const financialArray = total?.key_performance_indicator?.length && total?.key_performance_indicator?.slice(1).map((row) => ({
//                 label: row?.kpi,
//                 roe: row?.roe,
//                 roce: row?.roec,
//                 ronw: row?.ronw,
//                 eps: row?.eps,
//                 pre_ipo: row?.pre_ipo,
//                 post_ipo: row?.post_ipo
//                 //  label: 'ROCE' , value : row?.roc  
//                 // period: row.kpi.trim(),  // Trim to remove unwanted spaces or tabs
//                 // eps: row.eps || "N/A",
//                 // roe: row.roe || "N/A",
//                 // roec: row.roec || "N/A",
//                 // ronw: row.ronw || "N/A",
//                 // preIpo: row.pre_ipo || "N/A",
//                 // postIpo: row.post_ipo || "N/A"
//             }));

//             setPerformenceCal(financialArray)
//         }
//     }, [total])

//     const columnCapitalinfra = [
//         {
//             // title: "Company Name",
//             dataIndex: "label",
//             key: "label",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             // title: "Company Name",
//             dataIndex: "value",
//             key: "value",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//     ];

//     const columnReservation = [
//         {
//             title: "Investor Category",
//             dataIndex: "label",
//             key: "label",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Shares Offered",
//             dataIndex: "share",
//             key: "share",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },

//     ];

//     const columnInvitLotSize = [
//         {
//             title: "Category",
//             dataIndex: "application",
//             key: "application",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Lot(s)",
//             dataIndex: "lot",
//             key: "lot",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Qty",
//             dataIndex: "share",
//             key: "share",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Amount",
//             dataIndex: "ammount",
//             key: "ammount",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Reserved",
//             dataIndex: "reserved",
//             key: "reserved",
//             width: "50%", // Set width as a percentage of total table width
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         // textDecoration: "underline",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo text-center"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//     ];

//     const columnFinancial = [
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.period_ended,
//             dataIndex: "period",
//             key: "period",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.assets,
//             dataIndex: "assets",
//             key: "assets",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.revenue,
//             dataIndex: "revenue",
//             key: "revenue",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.net_worth,
//             dataIndex: "netWorth",
//             key: "netWorth",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.total_borrowing,
//             dataIndex: "totalBorrowing",
//             key: "totalBorrowing",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.profit_after_tax,
//             dataIndex: "profitAfterTax",
//             key: "profitAfterTax",
//             width: "25%",
//         },
//         {
//             title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.reserves_and_surpluse,
//             dataIndex: "reservesAndSurplus",
//             key: "reservesAndSurplus",
//             width: "20%",
//         }
//     ];

//     const columnPerformance = [
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     KPI
//                 </div>
//             ),
//             dataIndex: "label",
//             key: "label",
//             width: "20%", // Adjust width if necessary
//             render: (text) => (
//                 <span
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                     }}
//                     className="company-name-table table-cell-typo"
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     ROE
//                 </div>
//             ),
//             dataIndex: "roe",
//             key: "roe",
//             width: "15%",
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     ROCE
//                 </div>
//             ),
//             dataIndex: "roce",
//             key: "roce",
//             width: "15%",
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     RONW
//                 </div>
//             ),
//             dataIndex: "ronw",
//             key: "ronw",
//             width: "15%",
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     EPS
//                 </div>
//             ),
//             dataIndex: "eps",
//             key: "eps",
//             width: "10%",
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     PRE IPO (PE)
//                 </div>
//             ),
//             dataIndex: "pre_ipo",
//             key: "pre_ipo",
//             width: "12%",
//         },
//         {
//             title: () => (
//                 <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                     POST IPO (PE)
//                 </div>
//             ),
//             dataIndex: "post_ipo",
//             key: "post_ipo",
//             width: "12%",
//         },
//     ];

//     // const columns = Object.keys(total?.ipo_reservation?.length > 0 && total?.ipo_reservation[0] || {}).map((key) => ({
//     //     // title: key.replace(/_/g, " ").toUpperCase(),
//     //     title: () => (
//     //         <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//     //             { key.replace(/_/g, " ").toUpperCase()}
//     //         </div>
//     //     ),
//     //     dataIndex: key,
//     //     key: key,
//     //     // align: "center",
//     //     render: (text) => <span
//     //         style={{
//     //             display: "flex",
//     //             justifyContent: "flex-start",
//     //             whiteSpace: "nowrap",
//     //             overflow: "hidden",
//     //             textOverflow: "ellipsis",
//     //         }}
//     //         className="company-name-table"
//     //     >
//     //         {text}
//     //     </span>,
//     // }));

//     const formattedData = total?.ipo_reservation?.map(({ investor_category, shares_offered, no_of_shares }) => ({
//         investor_category,
//         shares_offered,
//         no_of_shares
//     }));

//     const columns = Object.keys((formattedData?.length > 0 && formattedData[0]) || {}).map((key) => ({
//         title: () => (
//             <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
//                 {key.replace(/_/g, " ").toUpperCase()}
//             </div>
//         ),
//         dataIndex: key,
//         key: key,
//         render: (text) => (
//             <span
//                 style={{
//                     display: "flex",
//                     justifyContent: "flex-start",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                 }}
//                 className="company-name-table"
//             >
//                 {text !== undefined && text !== null ? text : "-"}
//             </span>
//         ),
//     }));

//     const totalColumns = ["SHARES OFFERED", "NO OF SHARES"].map(col => col.toLowerCase().replace(/ /g, "_"));

//     const ipoReservation = Array.isArray(formattedData) ? total.ipo_reservation : [];

//     const totalSharesOffered = ipoReservation.reduce((sum, item) => sum + (Number(item["shares_offered"]) || 0), 0);
//     const totalNoOfShares = ipoReservation.reduce((sum, item) => sum + (Number(item["no_of_shares"]) || 0), 0);

//     const totalRow = {
//         investor_category: "TOTAL",
//         shares_offered: totalSharesOffered > 0 ? "100%" : "0%", // Ensure valid total percentage
//         no_of_shares: totalNoOfShares || 0, // Ensure valid total
//     };

//     // Compute percentage for each row, avoiding NaN values
//     const tableData = ipoReservation?.map((item) => ({
//         ...item,
//         shares_offered: totalSharesOffered
//             ? ((Number(item["shares_offered"]) || 0) / totalSharesOffered * 100).toFixed(2) + "%"
//             : "0%"
//     }));

//     // Append total row
//     tableData.push(totalRow);
//     const companyName = ipoDetailData?.company_name?.split(" ").slice(0, 2).join(" ") + " IPO";

//     return (
//         <>
//             <div className='mainDetailsPage'>

//                 <div className='content'>
//                     <p>
//                         {ipoDetailData?.company_name} IPO is a book-built offering worth {formatIndianPrice(ipoDetailData?.retail_offered)} crores. This includes a fresh issue of {formatIndianPrice(ipoDetailData?.fresh_issue_size) || 0.0} crore shares, totaling ₹{formatIndianPrice(ipoDetailData?.issue_size)} crores, along with an offer for sale of {formatIndianPrice(ipoDetailData?.offer_of_sale_value)} crore shares, which amounts to ₹{formatIndianPrice(ipoDetailData?.market_maker_offered)} crores.
//                     </p>
//                     <p>
//                         The bidding for {ipoDetailData?.company_name} IPO opened on {formatDate(ipoDetailData?.start_date)}, and closed on {formatDate(ipoDetailData?.end_date)}. The allotment was finalized on {formatDate(ipoDetailData?.allotment_date || '-')}. The shares made their debut on the {ipoDetailData?.listing_at_group} on {formatDate(ipoDetailData?.listing_date)}.
//                     </p>
//                     <p>
//                         {ipoDetailData?.company_name} IPO is priced between {formatIndianPrice(ipoDetailData?.ipo_max_value)} and {formatIndianPrice(ipoDetailData?.ipo_min_value)} per share. For retail investors, the minimum lot size is {formatIndianPrice(ipoDetailData?.bid_lot) || 0} shares, requiring an investment of {formatCurrency(ipoDetailData?.min_investment)}. For sNII (Small and New Institutional Investors), the minimum investment is {formatIndianPrice(ipoDetailData?.bid_lot) || 0} lots, or {ipoDetailData?.ipo_max_value} shares, with a total investment of ₹{formatIndianPrice(ipoDetailData?.max_investment)}.
//                     </p>
//                     <p className='' dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_strenght || "company strength information is not available." }} />
//                 </div>

//                 <div className='content-box'>
//                     <div className="flex flex-wrap ">
//                         {ipoDetailsCol?.length > 0 &&
//                             <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto blog_card">
//                                 <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                     <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                         {companyName} Details
//                                     </span>
//                                 </div>
//                                 <div className="">
//                                     {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
//                                     {capitalInfra?.description}
//                                 </h5> */}
//                                     <div className="table-wraper">
//                                         <CustomTable
//                                             className="ipo_blog_table prospect custom-table2"
//                                             columns={columnCapitalinfra}
//                                             data={ipoDetailsCol}
//                                             pagination={false}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         }

//                         {/*---------------------- Lot Size ------------------------------ */}
//                         {total?.ipo_lot_description?.length > 0 &&
//                             <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                                 <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                     <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                         {companyName} Lot Size
//                                     </span>
//                                 </div>

//                                 <div className='content-text'>
//                                     <p >
//                                         Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
//                                     </p>
//                                 </div>
//                                 <div className="">

//                                     <div className="table-wraper">
//                                         <CustomTable
//                                             className="ipo_blog_table prospect custom-table2"
//                                             columns={columnInvitLotSize}
//                                             data={lotSizeCol}
//                                             pagination={false}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         }
//                     </div>
//                     {total?.sharesData?.shares_offered > 0 && ipoReservationCol && (<>
//                         <div className="flex flex-col  xl:space-x-6">
//                             <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                                 <div className="mb-0  border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                     <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                         {companyName} Reservation
//                                     </span>
//                                 </div>

//                                 <div className="">
//                                     <div className="table-wraper">
//                                         <CustomTable
//                                             className="ipo_blog_table prospect custom-table2"
//                                             columns={columnReservation}
//                                             data={ipoReservationCol}
//                                             pagination={false}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/*---------------------- allotment_ipo ------------------------------ */}

//                             {/* <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                             <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                 <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                     Capital Infra Trust Invit Lot Size
//                                 </span>
//                             </div>

//                             <div className='content-text'>
//                                 <p >
//                                     Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
//                                 </p>
//                             </div>
//                             <div className="">

//                                 <div className="table-wraper">
//                                     <CustomTable
//                                         className="ipo_blog_table prospect"
//                                         columns={columnInvitLotSize}
//                                         data={lotSizeCol}
//                                         pagination={false}
//                                     />
//                                 </div>
//                             </div>
//                         </div> */}

//                         </div>
//                     </>)}

//                     {
//                         total?.company_financial_data?.financial_data?.length > 0 && (<>
//                             <div className="flex flex-col  ">
//                                 <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                                     <div className="mb-0  border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                         <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                             {companyName} Financial Information ( {ipoDetailData?.company_financial_data?.financial_amount_type} )
//                                         </span>
//                                     </div>

//                                     <div className="">
//                                         {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
//                                     {capitalInfra?.description}
//                                 </h5> */}
//                                         <div className="table-wraper">
//                                             <CustomTable
//                                                 className="ipo_blog_table prospect custom-table2"
//                                                 columns={columnFinancial}
//                                                 data={financialCol}
//                                                 pagination={false}
//                                             />
//                                         </div>
//                                         {/* <div className="flex justify-center py-10">
//                                     <Button
//                                         handleClick={() => {
//                                             navigate(PATHS?.IPODASHBOARD, { state: "prospectus_ipo" });
//                                         }}
//                                         classList="auth_submit_view_more"
//                                         content="More Mainboard IPO Prospectus (DRHP/RHP)"
//                                     />
//                                 </div> */}
//                                     </div>
//                                 </div>

//                                 {/*---------------------- allotment_ipo ------------------------------ */}

//                                 <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                                     <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                         <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                             {companyName} Key Performance Indicator
//                                         </span>
//                                     </div>

//                                     <div className='content-text'>
//                                         {/* <p >
//                                     Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
//                                 </p> */}
//                                     </div>
//                                     <div className="">

//                                         <div className="table-wraper">
//                                             <CustomTable
//                                                 className="ipo_blog_table prospect custom-table2"
//                                                 columns={columnPerformance}
//                                                 data={performenceCal}
//                                                 pagination={false}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>

//                             </div>
//                         </>)
//                     }

//                     {/* <div className="flex flex-wrap xl:space-x-6">
//                         <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
//                             <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
//                                 <span className="text-sm text-slate-600 font-medium header_blog_span">
//                                     {companyName} Reservation
//                                 </span>
//                             </div>
//                             <div className="table-wraper">
//                                 <CustomTable
//                                     className="ipo_blog_table prospect"
//                                     columns={columns} // ✅ Dynamic headers
//                                     data={tableData} // ✅ Dynamic data
//                                     pagination={false}
//                                 />
//                             </div>
//                         </div>
//                     </div> */}
//                 </div>
//                 <hr></hr>

//                 <section className='content-description'>
//                     {
//                         ipoDetailData?.about_the_company && (
//                             <>
//                                 <div className='mt-4 mb-5'>
//                                     <h3>
//                                         {companyName} About Company
//                                     </h3>
//                                     <div>
//                                         <p >
//                                             {ipoDetailData?.about_the_company}
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <hr></hr>
//                             </>)
//                     }

//                     {
//                         ipoDetailData?.company_strenght && (
//                             <>
//                                 <div className='mt-4 mb-5'>
//                                     <h3>
//                                         {companyName} Strength Factors
//                                     </h3>
//                                     <div>
//                                         <p dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_strenght }}>
//                                             {/* {ipoDetailData?.company_strenght} */}
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <hr></hr>
//                             </>)
//                     }

//                     {
//                         ipoDetailData?.company_strenght && (
//                             <>
//                                 <div className='mt-4 mb-5'>
//                                     <h3>
//                                         {companyName} Risk Factors
//                                     </h3>
//                                     <div>
//                                         <p dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_weakness }}>
//                                             {/* {ipoDetailData?.company_strenght} */}
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <hr></hr>
//                             </>)
//                     }

//                     {
//                         ipoDetailData?.lead_managers && (
//                             <>
//                                 <div className='mt-4 mb-5'>
//                                     <h3>
//                                         {companyName} Lead Manager(s)
//                                     </h3>
//                                     <div>
//                                         <p>
//                                             {ipoDetailData?.lead_managers}
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <hr></hr>
//                             </>)
//                     }
//                     {/* {
//                         ipoDetailData?.issue_objectives !== "NA" || ipoDetailData?.issue_objectives && (<>

//                             <div className='mt-4 mb-5'>
//                                 <h3>
//                                     Objects of the Issue {ipoDetailData?.company_name}
//                                 </h3>
//                                 <div>
//                                     <ul className='list-disc pl-5'>
//                                         <li className='list-none'>The Offer Proceeds will be utilised towards the following objects:</li>
//                                         <li>
//                                             Providing loans to the Project SPVs for repayment/pre-payment of external borrowings,
//                                             in part or in full, from the financial lenders (including any accrued interest and prepayment penalty).
//                                         </li>
//                                         <li>
//                                             Providing loans to the Project SPVs for repayment of unsecured loans availed by the Project SPVs from the Sponsor.
//                                         </li>
//                                     </ul>
//                                     <hr></hr>
//                                 </div>
//                             </div>
//                         </>)
//                     } */}

//                     <div className='mt-4 mb-5'>
//                         <div className="flex lg:justify-between flex-wrap">
//                             {/* <div className="w-full lg:w-[49%] company_details border blog_card"> */}
//                             <div className='relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto company_details w-full lg:w-[49%]'>
//                                 <h1>{companyName} Company Details</h1>
//                                 <div className='compant_containt p-3'>
//                                     <h5>{ipoDetailData?.company_name}</h5>
//                                     {/* <p>
//                                         Unit No. 1401-1403, 14th Floor, Tower B, SAS Tower, Medicity, Sector-38-Gurugram-122001
//                                     </p> */}
//                                     {/* <hr /> */}
//                                     {ipoDetailData?.company_address && typeof ipoDetailData?.company_address === 'object' ? (
//                                         Object.entries(ipoDetailData?.company_address).map(([key, value]) => (
//                                             value && (
//                                                 <div className="flex align-items-center p-2 m-2" key={key}>
//                                                     <h5 className="mr-2 text-capitalize">{key}:</h5>
//                                                     {
//                                                         key === 'Website' ?
//                                                             <a href={value} target="_blank" rel="noopener noreferrer" >
//                                                                 <label style={{ color: "#043873", cursor: "pointer" }}>{value}</label>
//                                                             </a>
//                                                             : key === 'Email' ? <a href={`mailto:${value}`} target="_blank" rel="noopener noreferrer">
//                                                                 <label style={{ color: "#043873", cursor: "pointer" }}>{value}</label>
//                                                             </a>
//                                                                 : <label>{value}</label>
//                                                     }
//                                                 </div>
//                                             )
//                                         ))
//                                     ) : null}
//                                 </div>
//                             </div>

//                             <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto company_details w-full lg:w-[49%]">
//                                 <h1>{companyName} Registrar</h1>
//                                 <div className='compant_containt p-3'>
//                                     <h5>{ipoDetailData?.registrar}</h5>
//                                     <div className="flex items-center p-2 m-2">
//                                         <h5 className="mr-2">Name:</h5>
//                                         <label>{registrar_name && registrar_name || "-"}</label>
//                                     </div>
//                                     <div className="flex items-center p-2 m-2">
//                                         <h5 className="mr-2">Phone:</h5>
//                                         <label>{registrar_phone && registrar_phone || '-'}</label>
//                                     </div>
//                                     <div className="flex items-center p-2 m-2">
//                                         <h5 className="mr-2">Email:</h5>
//                                         {registrar_email ? (
//                                             <a href={`mailto:${registrar_email}`} target="_blank" rel="noopener noreferrer">
//                                                 <label style={{ color: "#043873", cursor: "pointer" }}>{registrar_email}</label>
//                                             </a>
//                                         ) : (
//                                             <label>-</label>
//                                         )}
//                                     </div>
//                                     <div className="flex items-center p-2 m-2">
//                                         <h5 className="mr-2">Website:</h5>
//                                         {/* <label>{registrar_website && registrar_website || '-'}</label> */}
//                                         {registrar_website ? (
//                                             <a href={registrar_website} target="_blank" rel="noopener noreferrer" >
//                                                 <label style={{ color: "#043873", cursor: "pointer" }}>{registrar_website}</label>
//                                             </a>
//                                         ) : (
//                                             <label>-</label>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <h3>
//                         {companyName} FAQs
//                     </h3>
//                 </section>

//                 <div className='mt-4 mb-5'>
//                     <IpoAccordian ipoDetailData={ipoDetailData} />
//                 </div>
//             </div>
//         </>
//     )
// }

import React, { useEffect, useState } from 'react'
import CustomTable from '../../../components/customTable/customTable';
import Accordian from '../../../components/Accordian';
import { useDispatch, useSelector } from 'react-redux';
import IpoAccordian from '../../../components/IpoAccordian';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getIpoDetail } from '../../../api/IposApi';
import { startMasterLoding, stopMasterLoding } from '../../../store/slice/masterSlice';
import { setIpoDetail } from '../../../utils/npm';
import { formatCurrency, formatDate, formatIndianPrice, formatIPOValue, TABKEY } from '../../../components/CommonFunction';
import useIsMobile576 from '../../../hooks/useIsMobile576'

export const IpoDetails = ({ location }) => {

    const navigate = useNavigate();
    const { faqData, error, loading } = useSelector(state => state.fagListData)
    const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail)
    const isloading = useSelector((state) => state.masterSlice.isloading);
    const isMobile576 = useIsMobile576(576)

    const [total, setTotal] = useState([])
    const { id } = useParams();

    useEffect(() => {

        const totals = ipoDetailData?.ipo_subscription_detail?.length > 0 && ipoDetailData?.ipo_subscription_detail?.reduce(
            (acc, item) => {
                if (
                    item.category !== 'Total' &&
                    item.category.trim().toLowerCase() !== 'hnis(10l +)' &&
                    // item.category !== 'hnis(10l+)' &&
                    item.category.trim().toLowerCase() !== 'hnis (2-10l)'
                ) {
                    acc.times += item.times ?? 0
                    acc.offered += item.offered ?? 0
                    acc.applied += item.applied ?? 0
                }
                return acc
            },
            { times: 0, offered: 0, applied: 0 }
        )

        const investorCategoryTotal = ipoDetailData?.ipo_reservation?.reduce(
            (acc, item) => {
                if (item.investor_category !== 'Total') {
                    acc.no_of_shares += item.no_of_shares ?? 0
                    acc.shares_offered += item.shares_offered ?? 0
                }
                return acc
            },
            {
                no_of_shares: 0,
                shares_offered: 0
            }
        )

        const totalApplied = ipoDetailData?.appplication_wise_breakup?.data?.reduce(
            (accumulator, currentItem) => {
                const appliedValue = Number(currentItem.applied) || 0 // Ensure applied is numeric
                return accumulator + appliedValue
            },
            0
        )

        setTotal(prevState => ({
            ...prevState,
            ipo_subscription_detail: {
                ...prevState.ipo_subscription_detail,
                times: totals?.times,
                offered: totals?.offered,
                applied: totals?.applied
            },
            investorCategoryTotal: {
                ...prevState?.investorCategoryTotal,
                no_of_shares: investorCategoryTotal?.no_of_shares,
                shares_offered: investorCategoryTotal?.shares_offered
            },
            application_wise_breakup: {
                ...prevState?.application_wise_breakup,
                totalApplied: totalApplied
            },
            ipoDetails: {
                ipo_start_date: ipoDetailData?.start_date,
                ipo_end_date: ipoDetailData?.end_date,
                listing_date: ipoDetailData?.listing_date,
                allotment_date: ipoDetailData?.allotment_date,
                issue_size: ipoDetailData?.issue_size,
                issue_type: ipoDetailData?.issue_type?.issue_type,
                issue_price: ipoDetailData?.issue_price?.issue_price,
                issue_amount: ipoDetailData?.issue_amount,
                fresh_issue_size: ipoDetailData?.fresh_issue_size,
                fresh_issue_value: ipoDetailData?.fresh_issue_value,
                face_value: ipoDetailData?.face_value,
                // s_hni_lot_size : ipoDetailData?.s_hni_lot_size,
                bid_lot: formatIndianPrice(ipoDetailData?.bid_lot),
                listing_at_group: ipoDetailData?.listing_at_group,
                symbol: ipoDetailData?.symbol,
                post_issue_share_holding: ipoDetailData?.post_issue_share_holding,
                pre_issue_share_holding: ipoDetailData?.pre_issue_share_holding,
                price_range: ipoDetailData?.price_range,
                market_maker_offered: ipoDetailData?.market_maker_offered,
                offer_of_sale_value: ipoDetailData?.offer_of_sale_value,
                offer_of_sale: ipoDetailData?.offer_of_sale
            },
            ipo_lot_description: ipoDetailData?.ipo_lot_description,
            key_performance_indicator: ipoDetailData?.key_performance_indicator,
            company_financial_data: ipoDetailData?.company_financial_data,
            interest_cost_per_share: ipoDetailData?.interest_cost_per_share,
            ipo_reservation: ipoDetailData?.ipo_reservation
        }))

    }, [id, ipoDetailData])

    // ---------------------------- Details Data --------------------------------------

    const [ipoDetailsCol, setIpoDetailsCol] = useState([])
    const [ipoReservationCol, setIpoReservationCol] = useState([])
    const [lotSizeCol, setLotSizeCol] = useState([])
    const [financialCol, setFinancialCol] = useState([])
    const [performenceCal, setPerformenceCal] = useState([])

    const registrarDetails = ipoDetailData?.registrar_detail ? ipoDetailData.registrar_detail?.split(', ') : [];
    const [registrar_name, registrar_phone, registrar_email, registrar_website] = registrarDetails;

    useEffect(() => {

        if (total?.ipoDetails) {
            const ipoDetailArray = [
                { label: 'IPO Date', value: `${formatDate(total?.ipoDetails?.ipo_start_date)} to ${formatDate(total?.ipoDetails?.ipo_end_date)}` },
                { label: 'Allotment Date', value: `${total?.ipoDetails?.allotment_date != null ? formatDate(total?.ipoDetails?.allotment_date) : '-'}` },
                { label: 'List Date', value: `${total?.ipoDetails?.listing_date != null ? formatDate(total?.ipoDetails?.listing_date) : '' || '-'}` },
                { label: 'Lot Size', value: formatIndianPrice(total?.ipoDetails.bid_lot) + ' share' },
                { label: 'Issue Price', value: total?.ipoDetails?.price_range },
                { label: 'Issue Size', value: formatIndianPrice(total?.ipoDetails?.issue_size) + ` ( aggregating up to ${total?.ipoDetails.issue_amount || 0.00} Cr )` },
                { label: 'Fresh Issue', value: `${formatIndianPrice(total?.ipoDetails?.fresh_issue_value)} ( aggregating up to ${total?.ipoDetails?.fresh_issue_size || 0.00} Cr )` },
                { label: 'Offer For Sale', value: `${formatIndianPrice(total?.ipoDetails?.offer_of_sale)} ( aggregating up to ${total?.ipoDetails?.offer_of_sale_value || 0.00} Cr )` },

                // { label: 'Face Value', value: total?.ipoDetails?.face_value },
                { label: 'Listing At', value: total?.ipoDetails?.listing_at_group || '-' },
                { label: 'Share Holding Pre-Issue', value: formatIndianPrice(total?.ipoDetails?.pre_issue_share_holding) },
                { label: 'Share Holding Post-Issue', value: formatIndianPrice(total?.ipoDetails?.post_issue_share_holding) },
                { label: 'Market Marker Portion', value: formatIndianPrice(total?.ipoDetails?.market_maker_offered) },
            ];
            setIpoDetailsCol(ipoDetailArray);
        }

        if (total?.sharesData) {
            const ReservationArray = [
                { label: 'QIB Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 75% of the Offer' },
                { label: 'NII (HNI) Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 15% of the Offer' },
                { label: 'Retail Shares Offered', share: total?.sharesData?.shares_offered > 0 ? `${total?.sharesData?.shares_offered}% of the Offer` : 'Not more than 10% of the Offer' }
            ];
            setIpoReservationCol(ReservationArray);
        }

        if (total?.ipo_lot_description) {

            const LotSizeArray = total?.ipo_lot_description?.length > 0 && total?.ipo_lot_description?.map(item => ({
                label: 'IPO Date',
                application: item?.category === "RETAIL" ? "Retail (Min)" : item?.category,
                lot: item["lot(s)"].toString(),
                share: item?.qty?.toString(),
                ammount: formatIndianPrice(item?.amount),//formatIndianPrice(`₹${item?.amount?.toLocaleString()}`),
                reserved: item?.reserved
            }));

            setLotSizeCol(LotSizeArray);
        }

        if (total?.company_financial_data?.financial_data) {
            const financialArray = total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data?.slice(1).map((row) => ({
                period: row.period_ended,
                assets: `${row.assets}`,
                revenue: `${row.revenue}`,
                netWorth: `${row.net_worth}`,
                totalBorrowing: `${row.total_borrowing}`,
                profitAfterTax: `${row.profit_after_tax}`,
                reservesAndSurplus: `${row.reserves_and_surpluse}`,
            }));
            setFinancialCol(financialArray);
        }

        if (total?.key_performance_indicator?.length > 0) {
            const formattedKpiData = [
                // { label: "Kpi", value: kpi },
                { label: total?.key_performance_indicator[0]?.ronw, value: `${total?.key_performance_indicator[0]?.ronw}%` }, // RoNW
                { label: "Debt/Equity", value: "1.45" }, // Manually added (if available in the full dataset)
            ];

            const financialArray = total?.key_performance_indicator?.length && total?.key_performance_indicator?.slice(1).map((row) => ({
                label: row?.kpi,
                roe: row?.roe,
                roce: row?.roec,
                ronw: row?.ronw,
                eps: row?.eps,
                pre_ipo: row?.pre_ipo,
                post_ipo: row?.post_ipo
                //  label: 'ROCE' , value : row?.roc  
                // period: row.kpi.trim(),  // Trim to remove unwanted spaces or tabs
                // eps: row.eps || "N/A",
                // roe: row.roe || "N/A",
                // roec: row.roec || "N/A",
                // ronw: row.ronw || "N/A",
                // preIpo: row.pre_ipo || "N/A",
                // postIpo: row.post_ipo || "N/A"
            }));

            setPerformenceCal(financialArray)
        }
    }, [total])

    {
        /*---------------------- columnCapitalinfra ------------------------------ */
    }

    const columnCapitalinfra = [
        {
            // title: "Company Name",
            dataIndex: "label",
            key: "label",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            // title: "Company Name",
            dataIndex: "value",
            key: "value",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
    ];

    const columnReservation = [
        {
            title: "Inventory Category",
            dataIndex: "investor_category",
            key: "investor_category",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Shares Offers",
            dataIndex: "shares_offered",
            key: "shares_offered",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "No. of Shares",
            dataIndex: "no_of_shares",
            key: "no_of_shares",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },

    ];

    const columnInvitLotSize = [
        {
            title: "Category",
            dataIndex: "application",
            key: "application",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Lot(s)",
            dataIndex: "lot",
            key: "lot",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Qty",
            dataIndex: "share",
            key: "share",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Amount",
            dataIndex: "ammount",
            key: "ammount",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Reserved",
            dataIndex: "reserved",
            key: "reserved",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo text-center"
                >
                    {text}
                </span>
            ),
        },
    ];

    const columnFinancial = [
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.period_ended,
            dataIndex: "period",
            key: "period",
            width: "25%",
            // fixed: "left"
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.assets,
            dataIndex: "assets",
            key: "assets",
            width: "25%",
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.revenue,
            dataIndex: "revenue",
            key: "revenue",
            width: "25%",
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.net_worth,
            dataIndex: "netWorth",
            key: "netWorth",
            width: "25%",
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.total_borrowing,
            dataIndex: "totalBorrowing",
            key: "totalBorrowing",
            width: "25%",
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.profit_after_tax,
            dataIndex: "profitAfterTax",
            key: "profitAfterTax",
            width: "25%",
        },
        {
            title: total?.company_financial_data?.financial_data?.length > 0 && total?.company_financial_data?.financial_data[0]?.reserves_and_surpluse,
            dataIndex: "reservesAndSurplus",
            key: "reservesAndSurplus",
            width: "20%",
        }
    ];

    const columnPerformance = [
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    KPI
                </div>
            ),
            dataIndex: "label",
            key: "label",
            width: "20%", // Adjust width if necessary
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    ROE
                </div>
            ),
            dataIndex: "roe",
            key: "roe",
            width: "15%",
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    ROCE
                </div>
            ),
            dataIndex: "roce",
            key: "roce",
            width: "15%",
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    RONW
                </div>
            ),
            dataIndex: "ronw",
            key: "ronw",
            width: "15%",
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    EPS
                </div>
            ),
            dataIndex: "eps",
            key: "eps",
            width: "10%",
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    PRE IPO (PE)
                </div>
            ),
            dataIndex: "pre_ipo",
            key: "pre_ipo",
            width: "12%",
        },
        {
            title: () => (
                <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                    POST IPO (PE)
                </div>
            ),
            dataIndex: "post_ipo",
            key: "post_ipo",
            width: "12%",
        },
    ];

    // const columns = Object.keys(total?.ipo_reservation?.length > 0 && total?.ipo_reservation[0] || {}).map((key) => ({
    //     // title: key.replace(/_/g, " ").toUpperCase(),
    //     title: () => (
    //         <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
    //             { key.replace(/_/g, " ").toUpperCase()}
    //         </div>
    //     ),
    //     dataIndex: key,
    //     key: key,
    //     // align: "center",
    //     render: (text) => <span
    //         style={{
    //             display: "flex",
    //             justifyContent: "flex-start",
    //             whiteSpace: "nowrap",
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //         }}
    //         className="company-name-table"
    //     >
    //         {text}
    //     </span>,
    // }));

    const formattedData = total?.ipo_reservation?.map(({ investor_category, shares_offered, no_of_shares }) => ({
        investor_category,
        shares_offered,
        no_of_shares
    }));

    const columns = Object.keys((formattedData?.length > 0 && formattedData[0]) || {}).map((key) => ({
        title: () => (
            <div style={{ whiteSpace: "nowrap", textAlign: "left", fontWeight: 600 }} className="font-semibold">
                {key.replace(/_/g, " ").toUpperCase()}
            </div>
        ),
        dataIndex: key,
        key: key,
        render: (text) => (
            <span
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                className="company-name-table"
            >
                {text !== undefined && text !== null ? text : "-"}
            </span>
        ),
    }));

    const totalColumns = ["SHARES OFFERED", "NO OF SHARES"].map(col => col.toLowerCase().replace(/ /g, "_"));
    const ipoReservation = Array.isArray(formattedData) ? total.ipo_reservation : [];

    const totalSharesOffered = ipoReservation.reduce((sum, item) => sum + (Number(item["shares_offered"]) || 0), 0);
    const totalNoOfShares = ipoReservation.reduce((sum, item) => sum + (Number(item["no_of_shares"]) || 0), 0);

    const totalRow = {
        investor_category: "TOTAL",
        shares_offered: totalSharesOffered > 0 ? "100%" : "0%", // Ensure valid total percentage
        no_of_shares: totalNoOfShares || 0, // Ensure valid total
    };

    const tableData = ipoReservation?.map((item) => ({
        ...item,
        shares_offered: totalSharesOffered ? ((Number(item["shares_offered"]) || 0) / totalSharesOffered * 100).toFixed(2) + "%" : "0%"
    }));

    tableData?.push(totalRow);
    // setIpoReservationCol(totalRow)

    const companyName = ipoDetailData?.company_name?.split(" ").slice(0, 2).join(" ") + " IPO";


    return (
        <>
            <div className='mainDetailsPage'>
                <div className='content'>
                    <p>
                        {ipoDetailData?.company_name} IPO is a book-built offering worth {formatIndianPrice(ipoDetailData?.retail_offered)} crores. This includes a fresh issue of {formatIndianPrice(ipoDetailData?.fresh_issue_size) || 0.0} crore shares, totaling ₹{formatIndianPrice(ipoDetailData?.issue_size)} crores, along with an offer for sale of {formatIndianPrice(ipoDetailData?.offer_of_sale_value)} crore shares, which amounts to ₹{formatIndianPrice(ipoDetailData?.market_maker_offered)} crores.
                    </p>
                    <p>
                        The bidding for {ipoDetailData?.company_name} IPO opened on {formatDate(ipoDetailData?.start_date)}, and closed on {formatDate(ipoDetailData?.end_date)}. The allotment was finalized on {formatDate(ipoDetailData?.allotment_date || '-')}. The shares made their debut on the {ipoDetailData?.listing_at_group} on {formatDate(ipoDetailData?.listing_date)}.
                    </p>
                    <p>
                        {ipoDetailData?.company_name} IPO is priced between {formatIndianPrice(ipoDetailData?.ipo_max_value)} and {formatIndianPrice(ipoDetailData?.ipo_min_value)} per share. For retail investors, the minimum lot size is {formatIndianPrice(ipoDetailData?.bid_lot) || 0} shares, requiring an investment of {formatCurrency(ipoDetailData?.min_investment)}. For sNII (Small and New Institutional Investors), the minimum investment is {formatIndianPrice(ipoDetailData?.bid_lot) || 0} lots, or {ipoDetailData?.ipo_max_value} shares, with a total investment of ₹{formatIndianPrice(ipoDetailData?.max_investment)}.
                    </p>
                    <p className='' dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_strenght || "company strength information is not available." }} />
                </div>

                <div className='content-box'>
                    <div className="flex flex-wrap ">
                        {ipoDetailsCol?.length > 0 &&
                            <div className="relative responsive_table_col_2 left_side_column_head_style flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto blog_card">
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {companyName} Details
                                    </span>
                                </div>
                                <div className="">
                                    {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                                    {capitalInfra?.description}
                                </h5> */}
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect custom-table2"
                                            columns={columnCapitalinfra}
                                            data={ipoDetailsCol}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        {/*---------------------- Lot Size ------------------------------ */}
                        {total?.ipo_lot_description?.length > 0 &&
                            <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto responsive_table_col_5">
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {companyName}&nbsp;Lot Size
                                    </span>
                                </div>

                                <div className='content-text'>
                                    <p >
                                        Investors can bid for a minimum of&nbsp;150&nbsp;shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
                                    </p>
                                </div>
                                <div className="">

                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect custom-table2"
                                            columns={columnInvitLotSize}
                                            data={lotSizeCol}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    {total?.ipo_reservation?.length > 0 && (<>
                        <div className="flex flex-col  xl:space-x-6">
                            <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                                <div className="mb-0  border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {companyName} Reservation
                                    </span>
                                </div>

                                <div className="">
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect custom-table2"
                                            columns={columnReservation}
                                            data={total?.ipo_reservation}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                                {/* <div className="responsive_table_col_7">
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect custom-table2"
                                            columns={columnPerformance}
                                            data={performenceCal}
                                            pagination={false}
                                        />
                                    </div>
                                </div> */}
                            </div>

                            {/*---------------------- allotment_ipo ------------------------------ */}

                            {/* <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                    Capital Infra Trust Invit&nbsp;Lot Size
                                </span>
                            </div>

                            <div className='content-text'>
                                <p >
                                    Investors can bid for a minimum of&nbsp;150&nbsp;shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
                                </p>
                            </div>
                            <div className="">

                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnInvitLotSize}
                                        data={lotSizeCol}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        </div> */}

                        </div>
                    </>)}

                    {
                        total?.company_financial_data?.financial_data?.length > 0 && (<>
                            <div className="flex flex-col  ">
                                <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto responsive_table_col_7">
                                    <div className="mb-0  border-slate-200 pt-3 pb-2 px-5 header_blog">
                                        <span className="text-sm text-slate-600 font-medium header_blog_span">
                                            {companyName} Financial Information ( {ipoDetailData?.company_financial_data?.financial_amount_type} )
                                        </span>
                                    </div>

                                    <div className="">
                                        {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                                    {capitalInfra?.description}
                                </h5> */}
                                        <div className="table-wraper">
                                            <CustomTable
                                                className="ipo_blog_table prospect custom-table2"
                                                columns={columnFinancial}
                                                data={financialCol}
                                                pagination={false}
                                            />
                                        </div>
                                        {/* <div className="flex justify-center py-10">
                                    <Button
                                        handleClick={() => {
                                            navigate(PATHS?.IPODASHBOARD, { state: "prospectus_ipo" });
                                        }}
                                        classList="auth_submit_view_more"
                                        content="More Mainboard IPO Prospectus (DRHP/RHP)"
                                    />
                                </div> */}
                                    </div>
                                </div>

                                {/*---------------------- allotment_ipo ------------------------------ */}
                                {
                                    total?.ipo_reservation?.length > 0 &&
                                    <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                                        <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                            <span className="text-sm text-slate-600 font-medium header_blog_span">
                                                {companyName} Key Performance Indicator
                                            </span>
                                        </div>

                                        {/* <div className='content-text '> */}
                                        {/* <p >
                                    Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
                                </p> */}
                                        {/* </div> */}
                                        <div className="responsive_table_col_7">

                                            <div className="table-wraper">
                                                <CustomTable
                                                    className="ipo_blog_table prospect custom-table2"
                                                    columns={columnPerformance}
                                                    data={performenceCal}
                                                    pagination={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                        </>)
                    }

                    {/* <div className="flex flex-wrap xl:space-x-6">
                        <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                    {companyName} Reservation
                                </span>
                            </div>
                            <div className="table-wraper">
                                <CustomTable
                                    className="ipo_blog_table prospect"
                                    columns={columns} // ✅ Dynamic headers
                                    data={tableData} // ✅ Dynamic data
                                    pagination={false}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>
                <hr></hr>

                <section className='content-description'>
                    {
                        ipoDetailData?.about_the_company && (
                            <>
                                <div className='mt-2 md:mt-4 md:mb-5'>
                                    <h3>
                                        {companyName} About Company
                                    </h3>
                                    <div>
                                        <p >
                                            {ipoDetailData?.about_the_company}
                                        </p>
                                    </div>
                                </div>
                                <hr></hr>
                            </>)
                    }

                    {
                        ipoDetailData?.company_strenght && (
                            <>
                                <div className='mt-2 md:mt-4 md:mb-5'>
                                    <h3>
                                        {companyName} Strength Factors
                                    </h3>
                                    <div>
                                        <p dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_strenght }}>
                                            {/* {ipoDetailData?.company_strenght} */}
                                        </p>
                                    </div>
                                </div>
                                <hr></hr>
                            </>)
                    }

                    {
                        ipoDetailData?.company_strenght && (
                            <>
                                <div className='mt-2 md:mt-4 md:mb-5'>
                                    <h3>
                                        {companyName} Risk Factors
                                    </h3>
                                    <div>
                                        <p dangerouslySetInnerHTML={{ __html: ipoDetailData?.company_weakness }}>
                                            {/* {ipoDetailData?.company_strenght} */}
                                        </p>
                                    </div>
                                </div>
                                <hr></hr>
                            </>)
                    }

                    {
                        ipoDetailData?.lead_managers && (
                            <>
                                <div className='mt-2 md:mt-4 md:mb-5'>
                                    <h3>
                                        {companyName} Lead Manager(s)
                                    </h3>
                                    <div>
                                        <p>
                                            {ipoDetailData?.lead_managers}
                                        </p>
                                    </div>
                                </div>
                                <hr></hr>
                            </>)
                    }

                    {/* {
                        ipoDetailData?.issue_objectives !== "NA" || ipoDetailData?.issue_objectives && (<>

                            <div className='mt-2 md:mt-4 md:mb-5'>
                                <h3>
                                    Objects of the Issue {ipoDetailData?.company_name}
                                </h3>
                                <div>
                                    <ul className='list-disc pl-5'>
                                        <li className='list-none'>The Offer Proceeds will be utilised towards the following objects:</li>
                                        <li>
                                            Providing loans to the Project SPVs for repayment/pre-payment of external borrowings,
                                            in part or in full, from the financial lenders (including any accrued interest and prepayment penalty).
                                        </li>
                                        <li>
                                            Providing loans to the Project SPVs for repayment of unsecured loans availed by the Project SPVs from the Sponsor.
                                        </li>
                                    </ul>
                                    <hr></hr>
                                </div>
                            </div>
                        </>)
                    } */}

                    <div className='mt-2 md:mt-4 md:mb-5'>
                        <div className="flex lg:justify-between flex-wrap">
                            {/* <div className="w-full lg:w-[49%] company_details border blog_card"> */}
                            <div className='relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto company_details w-full lg:w-[49%]'>
                                <h1>{companyName} Company Details</h1>
                                <div className='compant_containt p-3'>
                                    <h5>{ipoDetailData?.company_name}</h5>
                                    {/* <p>
                                        Unit No. 1401-1403, 14th Floor, Tower B, SAS Tower, Medicity, Sector-38-Gurugram-122001
                                    </p> */}
                                    {/* <hr /> */}
                                    {ipoDetailData?.company_address && typeof ipoDetailData?.company_address === 'object' ? (
                                        Object.entries(ipoDetailData?.company_address).map(([key, value]) => (
                                            value && (
                                                <div className="flex  md:p-2 mb-1 md:m-2" key={key}>
                                                    <h5 className="mr-2 text-capitalize">{key}:</h5>
                                                    {
                                                        key === 'Website' ?
                                                            <a href={value} target="_blank" rel="noopener noreferrer" >
                                                                <label className='break-words' style={{ color: "#043873", cursor: "pointer" }}>{value}</label>
                                                            </a>
                                                            : key === 'Email' ? <a href={`mailto:${value}`} target="_blank" rel="noopener noreferrer">
                                                                <label style={{ color: "#043873", cursor: "pointer" }} className='break-words'>{value}</label>
                                                            </a>
                                                                : <label>{value}</label>
                                                    }
                                                </div>
                                            )
                                        ))
                                    ) : null}
                                </div>
                            </div>

                            <div className="relative flex flex-col my-3 md:my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto company_details w-full lg:w-[49%]">
                                <h1>{companyName} Registrar</h1>
                                <div className='compant_containt p-3'>
                                    <h5>{ipoDetailData?.registrar}</h5>
                                    <div className="flex  md:p-2 mb-1 md:m-2">
                                        <h5 className="mr-2">Name:</h5>
                                        <label>{registrar_name && registrar_name || "-"}</label>
                                    </div>
                                    <div className="flex  md:p-2 mb-1 md:m-2">
                                        <h5 className="mr-2">Phone:</h5>
                                        <label>{registrar_phone && registrar_phone || '-'}</label>
                                    </div>
                                    <div className="flex  md:p-2 mb-1 md:m-2">
                                        <h5 className="mr-2">Email:</h5>
                                        {registrar_email ? (
                                            <a href={`mailto:${registrar_email}`} target="_blank" rel="noopener noreferrer">
                                                <label style={{ color: "#043873", cursor: "pointer" }}>{registrar_email}</label>
                                            </a>
                                        ) : (
                                            <label>-</label>
                                        )}
                                    </div>
                                    <div className="flex  md:p-2 mb-1 md:m-2">
                                        <h5 className="mr-2">Website:</h5>
                                        {/* <label>{registrar_website && registrar_website || '-'}</label> */}
                                        {registrar_website ? (
                                            <a href={registrar_website} target="_blank" rel="noopener noreferrer" >
                                                <label style={{ color: "#043873", cursor: "pointer" }}>{registrar_website}</label>
                                            </a>
                                        ) : (
                                            <label>-</label>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isMobile576 &&
                        <h3>
                            {companyName}&nbsp;FAQs
                        </h3>
                    }
                </section>

                {!isMobile576 &&
                    <div className='mt-2 md:mt-4 md:mb-5'>
                        <IpoAccordian ipoDetailData={ipoDetailData} />
                    </div>
                }

            </div>
        </>
    )
}